import config from "@/config";

import moment from "moment";
import axios from "axios";
import Router from "@/router";
import { getSingleAtom, getSettings, newScript } from "@/api.js";
import { default as settings } from "./settings.js";
import store from '@/store'
import CryptoJS from 'crypto-js';


export async function $get(url, options) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, options)
            .then(resp => {
                if (resp.data.error && resp.data.error.match(/auth required/)) {
                    if (Router.history.current.name != "Auth") {
                        Router.replace({ name: "Auth" });
                    }
                    return;
                }
                resolve(resp.data);
            })
            .catch(err => {
                reject(err);
            });
    });
}

export async function $post(url, data, options) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, data, options)
            .then(resp => {
                if (resp.data.error && resp.data.error.match(/auth required/)) {
                    if (Router.history.current.name != "Auth") {
                        Router.replace({ name: "Auth" });
                    }
                    return;
                }
                resolve(resp.data);
            })
            .catch(err => {
                if (err.message.match(/401/)) {
                    if (Router.history.current.name != "Auth")
                        Router.replace({ name: "Auth" });
                    return;
                }
                reject(err);
            });
    });
}

export function humanFileSize(bytes, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024;
    if (Math.abs(bytes) < thresh) {
        return bytes + " B";
    }

    const units = si ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"] : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (
        Math.round(Math.abs(bytes) * r) / r >= thresh &&
        u < units.length - 1
    );

    return bytes.toFixed(dp) + " " + units[u];
}

export function objectToString(o) {
    return o ?
        Object.keys(o)
        .reduce(function(a, k) {
            if (o[k]) {
                if (typeof o[k] == "string" || typeof o[k] == "number") {
                    a.push(k + "=" + encodeURIComponent(o[k]));
                }
                if (typeof o[k] == "object") {
                    for (let item of o[k]) {
                        a.push(k + "[]" + "=" + encodeURIComponent(item));
                    }
                }
            }
            return a;
        }, [])
        .join("&") :
        "";
}

export async function showError(ctx, title, message, closable, timer) {
    ctx.$notify({
        title: title,
        message: message,
        type: "error"
    });
}

export async function loadLocalAtomInfo(id) {
    let data = await getSingleAtom(id);
    return new Promise((resolve, reject) => {
        if (data && data['error']) {
            resolve(data);
        } else {
            resolve(data["Atom"]);
        }

    });
}

export function sendPost(url = "", data = {}) {
    return fetch(url, {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        headers: {
            "Content-Type": "application/json"
        },
        redirect: "follow",
        referrer: "no-referrer",
        body: JSON.stringify(data)
    }).then(response => response.json());
}

export async function loadSettings() {
    let res = await getSettings();
    return new Promise((resolve, reject) => {
        store.dispatch('updateSettings', res["Settings"])
        resolve(res["Settings"]);
    });
}

export async function installAtom(id) {
    let info = await marketplaceAtomInfo(id);
    if (info.data) {

        console.log("got marketplace atom info:", info);
        info.data["install"] = true;
        saveAtom(info.data);
    } else {
        alert("Something went wrong");
    }
}

export async function cloneAtom(hash) {
    // check local atom
    let info = await marketplaceAtomInfo(hash);
    if (info.data) {
        console.log("got marketplace atom info:", info);
        info.data["install"] = true;
        saveAtom(info.data);
    } else {
        alert("Something went wrong");
    }
    // if there is no atom -> clone from market
}

// save atom
export async function saveAtom(data) {
    console.log("save atom: ", data);
    newScript(data)
        // sendPost("/api/atoms/save", data).then(resp => {
        //     if (resp.error == null) {} else {
        //         alert(resp.error);
        //     }
        // });
}

export async function getAPIKey() {
    return await getSettingByName("cloud_api_key");
}

export function getSettingByName(setting) {
    return new Promise(async(resolve, reject) => {
        let settings = await loadSettings();
        for (var k in settings) {
            if (settings[k] != undefined && k === setting) {
                resolve(settings[k]);
                return settings[k];
            }
        }
        reject(null);
    });
}

export async function publishAtomToMarketplace(data) {
    const _apiKey = await getSettingByName("cloud_api_key");
    const apiKey = _apiKey ? _apiKey : "";
    let res = await sendPost(`${config.gate_url}scripts/?key=${apiKey}`, data);
    return res;
}

export async function getScopesFromCloud(offset) {
    const _apiKey = await getSettingByName("cloud_api_key");
    const apiKey = _apiKey ? _apiKey : "";
    const res = await fetch(
        `${config.gate_url}scopes/?key=${apiKey}&offset=${offset}`
    );
    if (res) {
        const json = await res.json();
        return json;
    }
}

export async function exportScopeToCloud(scope) {
    const _apiKey = await getSettingByName("cloud_api_key");
    const apiKey = _apiKey ? _apiKey : "";
    let res = await sendPost(`${config.gate_url}scopes/?key=${apiKey}`, scope);
    return res;
}

export async function checkAPIKey(key) {
    let res = await fetch(`${config.gate_url}check/?key=${key}`);
    let data = await res.json();
    return data;
}

export function marketplaceScripts(options) {
    const e = async() => {
        const cloudAPIKey = await getSettingByName("cloud_api_key");
        const res = await fetch(
            `${config.gate_url}atoms/?key=${cloudAPIKey}&` +
            Object.keys(options)
            .reduce(function(a, k) {
                a.push(k + "=" + encodeURIComponent(options[k]));
                return a;
            }, [])
            .join("&")
        );
        if (res) {
            const json = await res.json();
            return json;
        }
    };
    return e();
}

export function marketplaceAtomsTags() {
    const e = async() => {
        const res = await fetch(`${config.gate_url}atoms/tags/`);
        if (res) {
            const json = await res.json();
            return json;
        }
    };
    return e();
}

export async function marketplaceAtomInfo(hash) {
    const value = await getSettingByName("cloud_api_key");
    const res = await fetch(
        `${config.gate_url}atoms/${hash}/info/?key=${value}`
    );
    if (res) {
        const json = await res.json();
        return json;
    }
}

export function generateAndDownload(filename, text) {
    var element = document.createElement("a");
    element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

export function capitalize(s) {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
}

export function addQueryParam(ctx, key, value) {
    let obj = Object.assign({}, ctx.$route.query);
    // ignore eq fields
    if (key in obj) {
        if (obj[key] === value) {
            return;
        } else {
            obj[key] = value;
        }
    } else {
        obj[key] = value;
    }
    ctx.$router.replace({
        ...ctx.$router.currentRoute,
        query: obj
    });
}

export function addQueryParamNoReload(ctx, key, value) {
    let hash = window.location.hash.substr(1);
    let obj = {};
    if (hash) {
        obj = hash.split("&").reduce(function(result, item) {
            var parts = item.split("=");
            result[parts[0]] = parts[1];
            return result;
        }, {});
    }

    // ignore eq fields
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);
    if (key in obj) {
        if (obj[key] === value) {
            return;
        } else {
            obj[key] = value;
        }
    } else {
        obj[key] = value;
    }

    history.replaceState(
        obj,
        null,
        ctx.$route.path +
        "#" +
        Object.keys(obj)
        .map(key => {
            return key + "=" + obj[key];
        })
        .join("&")
    );
}

export function removeQueryParam(ctx, key) {
    let obj = Object.assign({}, ctx.$route.query);
    if (key in obj) {
        delete obj[key];
        ctx.$router.replace({
            ...ctx.$router.currentRoute,
            query: obj
        });
    }
}

export function timeAgo(date) {
    return moment(date, "YYYY-MM-DD HH:mm:ss ZZ z").fromNow();
}
export async function generateEncriptionKey() {
    return window.crypto.subtle.generateKey({
            name: "AES-GCM",
            length: 256, //can be  128, 192, or 256
        },
        true, //whether the key is extractable (i.e. can be used in exportKey)
        ["encrypt", "decrypt"] //can "encrypt", "decrypt", "wrapKey", or "unwrapKey"
    )
}
export async function encryptData(data) {
    // const _apiKey = await getSettingByName("encryptio_key");
    //const apiKey = _apiKey ? _apiKey : "";
    // return CryptoJS.AES.encrypt(data, 'secret key 123').toString();
    let key = "example key 1234";
    key = CryptoJS.enc.Utf8.parse(key);
    let iv = CryptoJS.enc.Utf8.parse("1234567812345678");
    let encrypted = CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7
    });
    return encrypted.toString();

}
export function decryptData(data) {
    // const _apiKey = await getSettingByName("encryptio_key");
    //const apiKey = _apiKey ? _apiKey : "";
    var bytes = CryptoJS.AES.decrypt(data, 'secret key 123');
    var decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted

}
export function isHacker() {}


// WEBPACK FOOTER //
// ./src/utils.js